// extracted by mini-css-extract-plugin
export default {"form":"formUpdate_form__dIcpH","imgUpload":"formUpdate_imgUpload__oF05v","formGroup2":"formUpdate_formGroup2__efkjk","formGroup":"formUpdate_formGroup__2vUQO"};